// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/auth/module_access_mode.proto (package qliq_protobuf.auth, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum qliq_protobuf.auth.ModuleAccessMode
 */
export enum ModuleAccessMode {
  /**
   * @generated from enum value: MODULE_BOT_DESIGNS_ADMIN = 0;
   */
  MODULE_BOT_DESIGNS_ADMIN = 0,

  /**
   * @generated from enum value: MODULE_CARE_CAMPAIGNS_ADMIN = 1;
   */
  MODULE_CARE_CAMPAIGNS_ADMIN = 1,

  /**
   * @generated from enum value: MODULE_AUTO_CAMPAIGNS_ADMIN = 2;
   */
  MODULE_AUTO_CAMPAIGNS_ADMIN = 2,

  /**
   * @generated from enum value: MODULE_CHAT_WIDGETS_ADMIN = 3;
   */
  MODULE_CHAT_WIDGETS_ADMIN = 3,

  /**
   * @generated from enum value: MODULE_FAQS_ADMIN = 4;
   */
  MODULE_FAQS_ADMIN = 4,

  /**
   * @generated from enum value: MODULE_ONCALL_SCHEDULES_ADMIN = 5;
   */
  MODULE_ONCALL_SCHEDULES_ADMIN = 5,

  /**
   * @generated from enum value: MODULE_QUICK_FORMS_ADMIN = 6;
   */
  MODULE_QUICK_FORMS_ADMIN = 6,

  /**
   * @generated from enum value: MODULE_FORM_SUBMISSIONS_ADMIN = 7;
   */
  MODULE_FORM_SUBMISSIONS_ADMIN = 7,

  /**
   * @generated from enum value: MODULE_REPORTS_ADMIN = 8;
   */
  MODULE_REPORTS_ADMIN = 8,

  /**
   * @generated from enum value: MODULE_SELF_SCHEDULES_ADMIN = 9;
   */
  MODULE_SELF_SCHEDULES_ADMIN = 9,

  /**
   * @generated from enum value: MODULE_VIRTUAL_CONVERSATIONS_ADMIN = 10;
   */
  MODULE_VIRTUAL_CONVERSATIONS_ADMIN = 10,

  /**
   * @generated from enum value: MODULE_VISIT_PATHS_ADMIN = 11;
   */
  MODULE_VISIT_PATHS_ADMIN = 11,

  /**
   * @generated from enum value: MODULE_GROUP_SETTINGS_ADMIN = 12;
   */
  MODULE_GROUP_SETTINGS_ADMIN = 12,

  /**
   * @generated from enum value: MODULE_QUICK_SIGN_SUBMISSIONS_ADMIN = 13;
   */
  MODULE_QUICK_SIGN_SUBMISSIONS_ADMIN = 13,

  /**
   * @generated from enum value: MODULE_SUPER_ADMIN = 14;
   */
  MODULE_SUPER_ADMIN = 14,

  /**
   * @generated from enum value: MODULE_GPT_STORE_ADMIN = 15;
   */
  MODULE_GPT_STORE_ADMIN = 15,

  /**
   * @generated from enum value: MODULE_QUICK_SIGN_TEMPLATES_ADMIN = 16;
   */
  MODULE_QUICK_SIGN_TEMPLATES_ADMIN = 16,

  /**
   * @generated from enum value: MODULE_CAMPAIGN_APPOINTMENTS_ADMIN = 17;
   */
  MODULE_CAMPAIGN_APPOINTMENTS_ADMIN = 17,
}
// Retrieve enum metadata with: proto3.getEnumType(ModuleAccessMode)
proto3.util.setEnumType(ModuleAccessMode, "qliq_protobuf.auth.ModuleAccessMode", [
  { no: 0, name: "MODULE_BOT_DESIGNS_ADMIN" },
  { no: 1, name: "MODULE_CARE_CAMPAIGNS_ADMIN" },
  { no: 2, name: "MODULE_AUTO_CAMPAIGNS_ADMIN" },
  { no: 3, name: "MODULE_CHAT_WIDGETS_ADMIN" },
  { no: 4, name: "MODULE_FAQS_ADMIN" },
  { no: 5, name: "MODULE_ONCALL_SCHEDULES_ADMIN" },
  { no: 6, name: "MODULE_QUICK_FORMS_ADMIN" },
  { no: 7, name: "MODULE_FORM_SUBMISSIONS_ADMIN" },
  { no: 8, name: "MODULE_REPORTS_ADMIN" },
  { no: 9, name: "MODULE_SELF_SCHEDULES_ADMIN" },
  { no: 10, name: "MODULE_VIRTUAL_CONVERSATIONS_ADMIN" },
  { no: 11, name: "MODULE_VISIT_PATHS_ADMIN" },
  { no: 12, name: "MODULE_GROUP_SETTINGS_ADMIN" },
  { no: 13, name: "MODULE_QUICK_SIGN_SUBMISSIONS_ADMIN" },
  { no: 14, name: "MODULE_SUPER_ADMIN" },
  { no: 15, name: "MODULE_GPT_STORE_ADMIN" },
  { no: 16, name: "MODULE_QUICK_SIGN_TEMPLATES_ADMIN" },
  { no: 17, name: "MODULE_CAMPAIGN_APPOINTMENTS_ADMIN" },
]);

